import {qs} from '../qs'

const BASE_PATH = '/nmc/data'

export default {
  getCategories: type => ({
    url: `${BASE_PATH}/categories/${type}`,
    method: 'GET'
  }),
  getDataList: query => ({
    url: `${BASE_PATH}/list${qs(query, '?')}`,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/NMC.js